import Axios from "../../axios";
import { ApiCommonParams } from "../../@types/apiTypes";
import { ApiResponse } from "../../apiResponse";
import { commonApiParamsToApiParams } from "../../helpers/paramsHelpers";

// @param candidateData: object
// example:
// {
//   "name": "Balqees",
//   "email": "balqeesmohammadq.95@gmail.com",
//   "phone_number": "0799460663",
//   "mother_language": "Arabic",
//   "sponsorship_id": 1
// }
export function createCandidate(candidateData: object): Promise<ApiResponse> {
  return Axios.post("v1/liaisons/candidates", candidateData);
}
export function updateCandidateApi(candidateData: any): Promise<ApiResponse> {
  return Axios.put(`v1/liaisons/candidates/${candidateData.id}`, candidateData);
}
export function removeCandidateApi(id: any): Promise<ApiResponse> {
  return Axios.delete(`v1/liaisons/candidates/${id}`);
}
export function indexCandidates(
  commonApiParams: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams);
  return Axios.get("v1/liaisons/candidates", { params: params });
}
